import { render, staticRenderFns } from "./CollapseOfTheOrderFilter.vue?vue&type=template&id=c5b2bc10"
import script from "./CollapseOfTheOrderFilter.vue?vue&type=script&lang=js"
export * from "./CollapseOfTheOrderFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports